module.exports = __webpack_public_path__ + "5057148712_b0502827b6_b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/5057148712_b0502827b6_b.jpg
// module id = 834
// module chunks = 0